// extracted by mini-css-extract-plugin
export default {"MonthlyExamPreparation":"monthlyExamPreparation_MonthlyExamPreparation__Y2p2x","content":"monthlyExamPreparation_content__Cx3Ab"};